module.exports = __webpack_public_path__ + "files/06e1945deca6b0bb648504d28091c926.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags-5.png
// module id = 1631
// module chunks = 60